import React from 'react';

import {FormikCheckbox} from '~commonInfra/components/FormikCheckbox';

import { Messages } from '../../../codegen/Localize';
import { SettingsSection } from '../../components/common/SettingsSection';
import {componentRegistryEntry} from '../../general-settings/components/SettingsComponentRegistryFunctions';

export const NOTIFY_WHEN_CLIENT_NOT_RUNNING_FIELD = 'settings.siteAdminBridgeSettings.remoteAgentSettings.notificationForClientNotRunningEnabled';

export function BridgeClientNotRunningNotificationsSection() {
  return (
    <SettingsSection title={Messages.siteRemoteAgentSettingsAgentsSentNotificationHeader()}
                     testId={'bridge-client-not-running-notifications-section'}
                     description={Messages.siteRemoteAgentSettingsAgentsSentNotificationBody()}>

      <FormikCheckbox name={NOTIFY_WHEN_CLIENT_NOT_RUNNING_FIELD}
                      label={Messages.siteRemoteAgentSettingsAgentsSentNotificationCheckbox()}
                      testId={'notify-when-bridge-client-not-running'}>

      </FormikCheckbox>
    </SettingsSection>
  );
}

/* for registering the component in settings registry */
export const BridgeClientNotRunningNotificationsSectionSpecs = componentRegistryEntry({
  name: 'BridgeClientNotRunningNotificationsSection',
  component: BridgeClientNotRunningNotificationsSection
});
